<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.header" [subheader]="data.subheader_html" />
  </ng-container>

  <ng-container body>
    <email-campaign-contract-submitted [data]="data"></email-campaign-contract-submitted>
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
